module.exports = __webpack_public_path__ + "static/img/footer_banner.8faf9953.png";